<template>
  <ul
    :id="depth < 1 ? 'navigation' : ''"
    :class="depth < 1 ? 'bot_nav navigation' : 'sub-menu'"
  >
    <li v-if="used">
      <router-link
        :to="`${lang ? `/${lang}` : ''}/product-category/used/${used.slug}`"
      >
        <span class="nav_item_wrap">
          <span class="nav_title">{{ used.name }}</span>
        </span>
      </router-link>
    </li>
    <li
      v-for="node in nodes"
      :key="node.slug"
      :id="`menu-item-${node.slug}${path.match('used') ? '-used' : ''}`"
      :class="[
        'menu-item',
        'menu-item-type-custom',
        `menu-item-${node.slug}`,
        `${node.children.length ? ' menu-item-has-children' : ''}`,
        `menu-item-depth-${depth}`,
        node.published_used,
        node.used,
        getSpecialCssClass(node.children),
      ]"
    >
      <router-link
        :to="
          lang ? '/' + lang + path + '/' + node.slug : path + '/' + node.slug
        "
        :class="`${node.published_used}`"
      >
        <span class="nav_item_wrap">
          <span class="nav_title">{{ categoryName(node) }}</span>
        </span>
      </router-link>
      <!-- <MenuNode
        v-if="node.children.length && categoryName(node) == 'iPhone'"
        :nodes="node.children.slice(0, 13)"
        :depth="depth + 1"
        :path="`${path}/${node.slug}`"
        :iphone="categoryName(node)"
      /> -->
      <MenuNode
        v-if="node.children.length && getUsed(node.slug)"
        :nodes="node.children"
        :depth="depth + 1"
        :path="`${path}/${node.slug}`"
        :used="getUsed(node.slug)"
      />
      <MenuNode
        v-if="node.children.length && !getUsed(node.slug)"
        :nodes="node.children"
        :depth="depth + 1"
        :path="`${path}/${node.slug}`"
      />
    </li>
  </ul>
</template>

<script>
// import Catalog from '@/components/header/Catalog'
export default {
  name: 'MenuNode',
  // components: { Catalog },
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    depth: {
      type: Number,
      required: false,
      default: 0,
    },
    path: {
      type: String,
      required: false,
      default: '/product-category',
    },
    used: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    getUsed(nodeSlug) {
      const used = this.nodes.find(({ slug }) => slug === 'used')
      if (!used) {
        return
      }
      const usedMapping = Object.fromEntries(
        used.children.map(({ slug, name }) => [slug, name])
      )
      if (usedMapping[nodeSlug]) {
        return {
          slug: nodeSlug,
          name: usedMapping[nodeSlug],
        }
      }
    },
    categoryName(cat) {
      //console.log(cat)
      return cat[`name_${this.$i18n.locale}`] || cat.name || '.....'
    },
    getSpecialCssClass(children) {
      if (this.depth >= 1) {
        return ''
      }

      for (let i = 0; i < children.length; i++) {
        const node = children[i]
        if (node.children.length) {
          return 'menu-has-depth-2'
        }
      }

      return ''
    },
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
@media only screen and (max-width: 1439px) {
  .menu-item-televizory {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .menu-item-dyson {
    display: none;
  }
}
</style>
